import React from "react";
import { SERVICES } from "../data/site";

export default function Services() {
    return (
        <section
            id="servizi"
            data-testid="services-section"
            className="relative py-24 sm:py-32 bg-ink-surface/40 border-y border-white/5 overflow-hidden"
        >
            <div className="absolute -top-20 right-10 w-[400px] h-[400px] rounded-full bg-gold/5 blur-3xl" />
            <div className="absolute inset-0 bg-grid opacity-20" />

            <div className="container mx-auto px-4 sm:px-6 lg:px-10 relative">
                <div className="max-w-3xl">
                    <div className="font-manrope text-sm uppercase tracking-[0.3em] text-gold mb-4">
                        I Nostri Servizi
                    </div>
                    <h2
                        data-testid="services-title"
                        className="font-oswald font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[1]"
                    >
                        Tutto quello che{" "}
                        <span className="text-shimmer">serve davvero.</span>
                    </h2>
                    <p className="mt-6 font-manrope text-zinc-400 text-base sm:text-lg max-w-2xl">
                        Un servizio completo: consulenza in studio, check in presenza, test BIA e
                        app custom. Tutto incluso, zero sorprese.
                    </p>
                </div>

                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                    {SERVICES.map((s) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.id}
                                data-testid={`service-card-${s.id}`}
                                className="group relative overflow-hidden bg-ink border border-white/5 rounded-xl p-6 hover:border-gold/50 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(212,175,55,0.1)] transition-all duration-300"
                            >
                                <div className="flex items-start gap-4">
                                    <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center group-hover:bg-gold transition-colors duration-300">
                                        <Icon
                                            size={20}
                                            className="text-gold group-hover:text-ink transition-colors"
                                        />
                                    </div>
                                    <div className="min-w-0">
                                        <h3 className="font-oswald font-bold uppercase text-lg sm:text-xl text-white tracking-wide leading-tight">
                                            {s.name}
                                        </h3>
                                        <p className="mt-2 font-manrope text-sm text-zinc-400 leading-relaxed">
                                            {s.text}
                                        </p>
                                    </div>
                                </div>
                                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-gold/0 to-gold/5 opacity-0 group-hover:opacity-100 transition-opacity rounded-bl-full" />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
